import video from "@/services/video.service.js";
import videoApi from "@/services/videoHandler.service";
import Formatter from "@/functions/Formatter";
import Video from "@/models/Video";
import { NIL } from "uuid";

const state = {
  video_library: [],
};

const mutations = {
  SET_VIDEO_LIBRARY(state, data) {
    state.video_library = data;
  },
  ADD_VIDEO(state, vid) {
    state.video_library.push(vid);
  },
  UPDATE_VIDEO(state, vid) {
    const index = state.video_library.indexOf(
      (v) => v.fileGuid === vid.fileGuid
    );
    state.video_library[index] = vid;
  },
  REMOVE_VIDEO(state, vid) {
    state.video_library.splice(
      state.video_library.findIndex((v) => v.id === vid.id),
      1
    );
  },
};

const actions = {
  async fetchVideoLibrary({ commit }) {
    try {
      let resp = await video.getAll();
      let videos = [];
      for (let i = 0; i < resp.data.length; i++) {
        const vid = Formatter.formatVideo(resp.data[i]);
        videos.push(vid);
      }

      commit("SET_VIDEO_LIBRARY", videos);
      return videos;
    } catch (err) {
      console.log(err);
      return undefined;
    }
  },
  async fetchVideoById({ commit }, id) {
    try {
      let response = await video.getOne(id);
      let vid = Formatter.formatVideo(response.data);
      commit("SET_VIDEO_LIBRARY", vid);
      return vid;
    } catch (error) {
      console.log(error);
      return null;
    }
  },
  async uploadVideo({ commit }, content) {
    if (!content.raw) return;

    const fileName = await videoApi.uploadVideo(content.raw);

    return new Promise((resolve, reject) => {
      if (!fileName) {
        const errorMessage = "Video failed to upload";
        console.log(errorMessage);
        reject(errorMessage);
        return;
      }

      let fVid = new Video(
        fileName,
        "NIL",
        content.raw.name,
        NIL,
        NIL,
        NIL,
        NIL
      );
      let strapiVideo = video.upload(fVid);

      commit("ADD_VIDEO", strapiVideo);
      resolve(strapiVideo);
    });
  },
  async deleteVideo({ commit }, vid) {
    if (!vid || !vid.fileGuid) return null;

    const response = await videoApi.deleteVideo(vid.fileGuid);

    return new Promise((resolve, reject) => {
      if (response.status === 400 || response.status === 404) {
        reject(false);
        return;
      }

      commit("REMOVE_VIDEO", vid);
      video.delete(vid.id);
      resolve(true);
    });
  },
  async getStreamingUrls({ commit }, vid) {
    if (!vid) return;
    console.log(vid.fileGuid);
    const vidBlob = await videoApi.getStreamingUrls(vid.fileGuid);
    let responseVid = vid;
    responseVid.url1 = vidBlob.url;
    if (vidBlob.url2) responseVid.url2 = vidBlob.url2;
    let strapiVideo = video.update(responseVid.id, responseVid);
    commit("UPDATE_VIDEO", strapiVideo);
    return strapiVideo;
  },
  clearVideoLibrary({ commit }) {
    commit("SET_VIDEO_LIBRARY", []);
  },
};

const getters = {
  getVideoLibrary: (state) => {
    return state.video_library;
  },
  getVideoByID: (state, id) => {
    return state.video_library.find((v) => v.id === id);
  },
  getVideoByGuid: (state, guid) => {
    return state.video_library.find((v) => v.file_guid === guid);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
